import React, { memo } from "react";
import connect from "Shared/connect";
import { Main, Part } from "Shared/PageLayout";
import expandPlaceholders from "Shared/expand-placeholders";
import currentPageIsCheckout from "../../Checkout/Pages/Checkout/current-page-is-checkout";
import classnames from "classnames";
import * as headerstyle from "./footer-header.scss";
import * as styles from "./base.scss";
import AboveFooter from "./AboveFooter";
const copyrightText = (text) => expandPlaceholders(text, { year: new Date().getFullYear() });
const MainFooter = memo((props) => {
    if (props.currentPageIsCheckout) {
        return React.createElement("noscript", null);
    }
    return (React.createElement("footer", null,
        React.createElement(AboveFooter, Object.assign({}, props)),
        React.createElement(Main, { layout: "1to1", className: styles.thirdArea },
            React.createElement(Part, null,
                React.createElement("div", { className: headerstyle.h4 }, props.footer.bottomAreaTitle),
                React.createElement("span", null, props.footer.bottomAreaBody)),
            React.createElement(Part, { className: classnames(styles.thirdArea, styles.copyright) },
                React.createElement("span", null, copyrightText(props.footer.copyrightText))))));
});
export default connect((state) => ({
    currentBreakpoint: state.currentBreakpoint,
    footer: state.footer,
    currentPageIsCheckout: currentPageIsCheckout(state.currentPage),
}))(MainFooter);
